import { City } from '@/models/City';
import { Property } from '@/models/Property';
import { fetchApi, postApi } from '@/api';

// Public pages use an isolated model, never the staff repository cache or private record loaders.
export class PublicCity extends City {
  constructor({ id, data }) {
    super({ data });
    this.publicId = id;
  }

  get id() {
    return this.publicId;
  }

  get isPublicView() {
    return true;
  }

  propertyFromResponse({ id, data }) {
    return new Property(this, {
      ref: { id },
      data
    });
  }

  async getProperty(id) {
    const { property } = await fetchApi(
      `/v1/public/cities/${encodeURIComponent(this.id)}/properties/${encodeURIComponent(id)}`
    );

    return this.propertyFromResponse(property);
  }

  async normalizeProperty(query) {
    const { properties } = await fetchApi(
      `/v1/public/cities/${encodeURIComponent(this.id)}/properties?q=${encodeURIComponent(query)}`
    );

    return properties.map(p => this.propertyFromResponse(p));
  }

  searchProperties(query) {
    return this.normalizeProperty(query);
  }

  reportMissingProperty(input) {
    return postApi(`/v1/public/cities/${encodeURIComponent(this.id)}/property-search-reports`, {
      input
    });
  }

  static async load(id) {
    const { city } = await fetchApi(`/v1/public/cities/${encodeURIComponent(id)}`);

    return new PublicCity(city);
  }

  static async list() {
    const { cities } = await fetchApi('/v1/public/cities');

    return cities.map(city => new PublicCity(city));
  }
}
